export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.8adb1d0c.OTF";